import IAddress from "./protocols/IAddress";
import IUser from "./protocols/IUser";

export default class User implements IUser {
  private _group_id = 0;
  private _website_id = 0;
  private _store_id = 0;
  private _addresses: IAddress[] = [];
  private _email: string = "";
  private _firstName: string = "";
  private _lastName: string = "";
  private _token: string = "";
  private _id = 0;
  private _loggedIn = false;

  get email(): string {
    return this._email;
  }

  set email(value: string) {
    this._email = value;
  }

  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get name(): string {
    return this.firstName + " " + this.lastName;
  }

  get loggedIn(): boolean {
    return this._loggedIn;
  }

  set loggedIn(value: boolean) {
    this._loggedIn = value;
  }

  get addresses(): IAddress[] {
    return this._addresses;
  }

  set addresses(value: IAddress[]) {
    this._addresses = value;
  }

  get group_id(): number {
    return this._group_id;
  }

  set group_id(value: number) {
    this._group_id = value;
  }

  get website_id(): number {
    return this._website_id;
  }

  set website_id(value: number) {
    this._website_id = value;
  }

  get store_id(): number {
    return this._store_id;
  }

  set store_id(value: number) {
    this._store_id = value;
  }

  toJSON(): any {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      id: this.id,
      group_id: this.group_id,
      website_id: this.website_id,
      store_id: this.store_id,
      token: this.token,
      loggedIn: this.loggedIn,
      addresses: this.addresses,
    };
  }
}
